import { isValid } from 'domain/components/application/validate';
import { ApplicationStep } from '../../domain/enums/ApplicationStep';
import DraftApplication from '../../domain/types/DraftApplication';

export default function getMaxAvailableStep(data: DraftApplication) {
  for (const iterator of Object.values(ApplicationStep)) {
    if (typeof iterator === 'number' && !isValid(iterator, data)) {
      return iterator;
    }
  }

  return ApplicationStep.review;
}
